// extracted by mini-css-extract-plugin
export var root = "FooterSocials-module--root--1d01a";
export var socialLink = "FooterSocials-module--socialLink--682b0";